import React from "react";

const getInitials = (name) => {
  if (!name) return "";
  const parts = name.trim().split(" ");
  return parts.map((part) => part[0]).slice(0, 2).join("").toUpperCase();
};

const stringToColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = hash % 360;
  return `hsl(${hue}, 70%, 50%)`;
};

const Avatar = ({ name, photoUrl }) => {
  const initials = getInitials(name);
  const isPhotoValid = photoUrl && photoUrl !== "null" && photoUrl !== "undefined";

  return isPhotoValid ? (
    <img
      src={photoUrl}
      alt="User"
      style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }}
    />
  ) : (
    <div
      style={{
        width: 32,
        height: 32,
        borderRadius: "50%",
        backgroundColor: stringToColor(name),
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        fontSize: 14,
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;